import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import localStorage from '@/utils/localStorage';
import { namespace } from 'vuex-class';
import Throttling from '@/utils/throttling';
var Common = namespace('common');

var AnnounceList = function (_super) {
  __extends(AnnounceList, _super);

  function AnnounceList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isShowLoadMore = false;
    _this.curAnnounceId = 0;
    _this.showAnnounceList = [];
    _this.announceDetail = {};
    _this.searchData = _this.initSearch();
    _this.readStatusList = [{
      value: -1,
      label: _this.t('全部')
    }, {
      value: 0,
      label: _this.t('未读')
    }, {
      value: 1,
      label: _this.t('已读')
    }];
    _this.activeAnnounceCate = 0;
    _this.announceList = [];
    _this.listDataPending = false;
    _this.page = 1;
    _this.pageSize = 10;
    _this.total = 0;
    _this.totalPage = 0;
    _this.tabsArr = [];
    return _this;
  }

  AnnounceList.prototype.created = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.initTabsArr();
            return [4, Promise.all([this.queryAnnounceCateList(), this.getAnnounceCateId()])];

          case 1:
            _a.sent();

            this.getAnnounceCateId();
            this.queryAnnounceList();
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.getInitTabsArr = function () {
    return [{
      title: this.t('全部'),
      id: 0,
      sort_id: 0
    }];
  };

  AnnounceList.prototype.initTabsArr = function () {
    var localTabsArr = localStorage.get('announceTabsArr');

    if (localTabsArr) {
      this.tabsArr = localTabsArr;
    } else {
      this.tabsArr = this.getInitTabsArr();
    }
  };

  AnnounceList.prototype.initPage = function () {
    this.page = 1;
    this.showAnnounceList = [];
  };

  AnnounceList.prototype.initSearch = function () {
    return {
      is_acked: -1,
      keyword: ''
    };
  };

  AnnounceList.prototype.queryAnnounceCateList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var cateData, _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.listDataPending = true;
            return [4, this.$api.announce.queryAnnounceCateList()];

          case 1:
            cateData = _b.sent().data;
            _a = cateData.data, data = _a === void 0 ? [] : _a;
            this.listDataPending = false;
            this.tabsArr = this.getInitTabsArr().concat(data);
            localStorage.set('announceTabsArr', JSON.stringify(this.tabsArr));
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.getAnnounceCateId = function () {
    var storageKey = ~~this.$route.query.cate;
    var theTab = this.tabsArr.find(function (item) {
      return item.id === storageKey;
    });
    this.activeAnnounceCate = theTab ? theTab.id : 0;
  };

  AnnounceList.prototype.queryAnnounceList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var sendData, pageData, resData, _a, data, _b, total;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.listDataPending = true;
            sendData = {
              type_id: this.activeAnnounceCate === 0 ? undefined : this.activeAnnounceCate,
              keyword: this.searchData.keyword,
              pre_tags: '<em class=\'highlight-text\'>',
              post_tags: '</em>'
            };

            if (this.searchData.is_acked !== -1) {
              sendData.is_acked = this.searchData.is_acked;
            }

            pageData = {
              page_index: this.page,
              page_size: this.pageSize
            };
            return [4, this.$api.announce.queryAnnounceList(Object.assign(sendData, pageData))];

          case 1:
            resData = _c.sent().data;
            this.listDataPending = false;
            _a = resData.data, data = _a === void 0 ? [] : _a, _b = resData.total, total = _b === void 0 ? 0 : _b;
            this.announceList = data;
            this.total = total;
            this.totalPage = Math.ceil(this.total / this.pageSize);
            this.isShowLoadMore = this.page < this.totalPage;
            this.setShowAnnounceListData();
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.setShowAnnounceListData = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            (_a = this.showAnnounceList).push.apply(_a, this.announceList);

            if (this.searchData.keyword) {
              this.showAnnounceList = this.showAnnounceList.map(function (item) {
                var reg = new RegExp("(" + _this.$util.escapeRegExp(_this.searchData.keyword) + ")", 'g');
                item.title = item.title.replace(reg, "$1");
                item.content = item.content.replace(reg, "$1");
                return item;
              });
            }

            if (this.showAnnounceList && this.showAnnounceList.length) {
              this.announceDetail = this.showAnnounceList[0];
              this.curAnnounceId = this.announceDetail.id;
            } else {
              this.announceDetail = {};
              this.curAnnounceId = 0;
            }

            return [4, this.handleAckAnnounce(this.announceDetail)];

          case 1:
            _b.sent();

            this.$nextTick(function () {
              _this.setListAndDetailBoxH();

              _this.$store.dispatch('user/updateUnreadTotal');
            });
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.setListAndDetailBoxH = function () {
    var noticeListBox = document.getElementById('noticeListBoxId');
    var noticeContenBox = document.getElementById('noticeContentId');
    var noticeAttachmentBox = document.getElementById('noticeAttachmentId');
    var noticeDetailBox = document.getElementById('noticeDetailBoxId');
    var noticeContenBoxH = noticeContenBox ? noticeContenBox.clientHeight : 0;
    var noticeAttachmentBoxH = noticeAttachmentBox ? noticeAttachmentBox.clientHeight : 0;
    var detailH = noticeContenBoxH + noticeAttachmentBoxH + 40;
    var minHeight = 900;

    if (detailH > minHeight) {
      noticeListBox.style.height = detailH + 'px';
    } else if (detailH && detailH < minHeight) {
      noticeListBox.style.height = minHeight + 'px';
      var height = this.announceDetail && this.announceDetail.content ? minHeight : 0;
      noticeDetailBox.style.height = height + 'px';
    }
  };

  AnnounceList.prototype.handleSearchNoticeList = function () {
    this.initPage();
    this.queryAnnounceList();
  };

  AnnounceList.prototype.handleLoadMore = function () {
    this.page += 1;
    this.queryAnnounceList();
  };

  AnnounceList.prototype.handleTabChange = function (key) {
    this.initPage();
    this.announceDetail = {};
    this.searchData = this.initSearch();
    this.queryAnnounceList();
  };

  AnnounceList.prototype.handleReadStatusChange = function () {
    console.log('切换状态');
    this.initPage();
    this.queryAnnounceList();
  };

  AnnounceList.prototype.handleClickAnnounce = function (data) {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.announceDetail = data || {};
            this.curAnnounceId = data.id;
            return [4, this.handleAckAnnounce(data)];

          case 1:
            _a.sent();

            this.handleScrollToTop();
            this.$nextTick(function () {
              _this.setListAndDetailBoxH();
            });
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.handleAckAnnounce = function (data) {
    return __awaiter(this, void 0, Promise, function () {
      var res;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(data && data.acked === this.$enum.common.BoolIntEnum.NO)) return [3, 2];
            return [4, this.$api.announce.ackAnnounce({
              id_list: [data.id]
            }, {
              showError: false,
              loading: false
            })];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.showAnnounceList.forEach(function (item) {
                if (item.id === data.id) {
                  item.acked = _this.$enum.common.BoolIntEnum.YES;
                }
              });
              this.$store.dispatch('user/updateUnreadTotal');
            }

            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  AnnounceList.prototype.handleScrollToTop = function () {
    return __awaiter(this, void 0, void 0, function () {
      var throttling;
      return __generator(this, function (_a) {
        throttling = new Throttling();
        throttling.handle(function () {
          document.querySelector('#layout-main').scrollTop = 0;
        });
        return [2];
      });
    });
  };

  AnnounceList = __decorate([Component], AnnounceList);
  return AnnounceList;
}(Vue);

export default AnnounceList;